import {
  APPLE_PAY_EMAIL,
  CASH_APP_URL,
  CompanyName,
  FULL_BUSINESS_URL,
  THRONE_URL,
  VENMO_URL,
} from '../Constants';


export const faqPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: `How do I book a session with ${CompanyName}?`,
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'All session requests must be made through My contact page, with a proper tribute submitted in advance. Only respectful inquiries will be considered.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are the tribute requirements?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Tributes vary depending on the type and duration of the session. Full details can be found on My bookings page or requested via direct inquiry.',
      },
    },
    {
      '@type': 'Question',
      name: `What should I know before serving ${CompanyName}?`,
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Obedience, respect, and a willingness to submit are essential. Be sure to read the full FAQ before making any requests.',
      },
    },
  ],
};

export const faqPageAdditionalMeta = [
  { property: 'og:title', content: `FAQ - Serving ${CompanyName}` },
  {
    property: 'og:description',
    content:
      `Answers to your most common questions about serving ${CompanyName}, tribute expectations, and booking protocol.`,
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/faq` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `FAQ - Serving ${CompanyName}` },
  {
    name: 'twitter:description',
    content:
      `Everything you need to know before approaching ${CompanyName}. Read carefully before inquiring.`,
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
];

// Links & Pay Sites Page
export const linksPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Exclusive Links & Tribute Options - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/links`,
  description: `Discover all official ways to connect with ${CompanyName}, including premium content, tribute options, and private platforms.`,
  sameAs: [
    `${THRONE_URL}`,
    `${CASH_APP_URL}`,
    `${VENMO_URL}`,
    `${APPLE_PAY_EMAIL}`,
  ],
};

export const linksPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Exclusive Links & Tribute Options - ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Explore all official platforms where you can connect, indulge, and tribute to ${CompanyName}.`,
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/links` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Exclusive Links & Tribute Options - ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Access premium content, tribute options, and exclusive ways to engage with ${CompanyName}.`,
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/brand/logo.png` },
];

// Gallery page
export const galleryPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: `${CompanyName} Gallery`,
  url: `${FULL_BUSINESS_URL}/gallery`,
  description: `Immerse yourself in the captivating visuals of ${CompanyName}. A glimpse into power, elegance, and seduction.`,
  isPartOf: {
    '@type': 'WebSite',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
};

export const galleryPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Gallery` },
  {
    property: 'og:description',
    content:
      'Step into a visual journey of dominance, seduction, and power. Witness My world through the lens.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/gallery/cover.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/gallery` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Gallery` },
  {
    name: 'twitter:description',
    content:
      'Explore an exquisite collection of images that capture the essence of My world.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/gallery/cover.jpg` },
];

export const clipsPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: `${CompanyName} Clips`,
  url: `${FULL_BUSINESS_URL}/clips`,
  description: `Unlock exclusive content, private clips, and premium experiences from ${CompanyName}. Indulge in My world beyond the ordinary.`,
  isPartOf: {
    '@type': 'WebSite',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
};

export const clipsPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Clips` },
  {
    property: 'og:description',
    content:
      `Access premium content, private clips, and exclusive fansite experiences from ${CompanyName}. Indulge in My world beyond the ordinary.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/clips/cover.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/clips` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Clips` },
  {
    name: 'twitter:description',
    content:
      'Explore a collection of My most exclusive content, available on premium clips and.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/clips/cover.jpg`,
  },
];

export const fansitesPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: `${CompanyName} Fansites`,
  url: `${FULL_BUSINESS_URL}/clips-fansites`,
  description: `Unlock exclusive content, private clips, and premium experiences from ${CompanyName}. Indulge in My world beyond the ordinary.`,
  isPartOf: {
    '@type': 'WebSite',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
};

export const fansitesPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Fansites` },
  {
    property: 'og:description',
    content:
      `Access premium content, private clips, and exclusive fansite experiences from ${CompanyName}. Indulge in My world beyond the ordinary.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/clips-fansites/cover.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/clips-fansites` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Clips & Fansites` },
  {
    name: 'twitter:description',
    content:
      'Explore a collection of My most exclusive content, available on premium clips and fansites.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/clips-fansites/cover.jpg`,
  },
];

// Maintenance
export const maintenancePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Maintenance Page',
  description: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back soon!`,
  url: `${FULL_BUSINESS_URL}/maintenance`,
};

export const maintenancePageAdditionalMeta = [
  { property: 'og:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    property: 'og:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/maintenance` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `The ${CompanyName} website is currently undergoing maintenance. We’ll be back shortly with exciting updates.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
];

// Policies page
export const termsAndPoliciesStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Terms and Policies',
  description: `Explore the terms of service and privacy policies of ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/terms-and-policies`,
  mainEntity: {
    '@type': 'FAQPage',
    name: 'Terms and Policies FAQ',
    description: `Frequently asked questions about terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
};

export const termsAndPoliciesAdditionalMeta = [
  { property: 'og:title', content: `Terms and Policies - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Understand the terms of service, privacy policies, and compliance guidelines of ${CompanyName}.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/terms-and-policies` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Terms and Policies - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Learn more about our terms of service, privacy policies, and compliance at ${CompanyName}.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
];

// Error page
export const errorPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '404 Error Page',
  description: `The requested page could not be found on ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/404`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const errorPageAdditionalMeta = [
  { property: 'og:title', content: 'Page Not Found - 404' },
  {
    property: 'og:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/404` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Page Not Found - 404' },
  {
    name: 'twitter:description',
    content: `Oops! The page you’re looking for isn’t here. Visit ${CompanyName} to find what you need.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
];

export const testimonialsPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `Testimonials - ${CompanyName}`,
  url: `${FULL_BUSINESS_URL}/testimonials`,
  description: `Explore authentic testimonials from devoted admirers and devoted submissives of ${CompanyName}. Discover their experiences and the unforgettable encounters that define true submission.`,
  mainEntity: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
};

export const testimonialsPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `Testimonials - Devotion to ${CompanyName}`,
  },
  {
    property: 'og:description',
    content: `Read the words of those who have submitted to ${CompanyName}. Explore their experiences of discipline, indulgence, and absolute devotion.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/testimonials-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/testimonials` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `Testimonials - Devotion to ${CompanyName}`,
  },
  {
    name: 'twitter:description',
    content: `Discover real testimonials from those who have surrendered to ${CompanyName}. Their experiences speak of devotion, discipline, and unforgettable encounters.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/testimonials-preview.jpg`,
  },
];

// Contact page
export const contactPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  mainEntity: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      areaServed: 'GB',
      availableLanguage: ['English'],
    },
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
};

export const contactPageAdditionalMeta = [
  { property: 'og:title', content: `Contact ${CompanyName}` },
  {
    property: 'og:description',
    content: `Reach out to ${CompanyName} for professional web and circuit design solutions. We're ready to discuss your projects and answer any questions.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/contact-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/contact` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Contact ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Contact ${CompanyName} for expert web and circuit design services. Let's discuss your needs and find the best solution.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/contact-preview.jpg`,
  },
];

// Bio page
export const AboutPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: `${CompanyName}`,
  url: FULL_BUSINESS_URL,
  jobTitle: 'Professional Dominatrix',
  description:
    `${CompanyName} is a powerful and elite Dominatrix offering exclusive experiences for those who seek true submission.`,
  image: {
    '@type': 'ImageObject',
    url: `${FULL_BUSINESS_URL}/brand/mistress-jewell-profile.jpg`,
  },
  knowsAbout: [
    'Female Domination',
    'BDSM',
    'Fetish Exploration',
    'Power Exchange',
    'Sadism & Masochism',
  ],
};

export const AboutPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `${CompanyName} – Divine Dominance & Control`,
  },
  {
    property: 'og:description',
    content:
      `Step into the world of ${CompanyName}, where power, seduction, and control reign supreme. Discover what true submission means.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-jewell-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/bio` },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `${CompanyName} – Divine Dominance & Control`,
  },
  {
    name: 'twitter:description',
    content:
      `Explore the exquisite dominance of ${CompanyName}. Bow before true power and devotion.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-jewell-preview.jpg`,
  },
];

// Sessions page
export const sessionsPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: `Liyah Minx's Sessions & Tribute`,
  provider: {
    '@type': 'Person',
    name: `${CompanyName}`,
    url: FULL_BUSINESS_URL,
  },
  serviceType: 'Elite Dominatrix Sessions',
  description:
    `Indulge in your deepest fantasies with ${CompanyName}. Explore a world of power, control, and submission in a personalized session tailored to your desires.`,
  offers: {
    '@type': 'Offer',
    priceCurrency: 'GBP',
    price: 'Varies',
    url: `${FULL_BUSINESS_URL}/sessions`,
  },
  areaServed: 'GB',
};
export const sessionsPageAdditionalMeta = [
  { property: 'og:title', content: `Sessions & Tribute – ${CompanyName}` },
  {
    property: 'og:description',
    content:
      `Step into Liyah Minx's domain and experience the thrill of submission. Explore a variety of elite domination sessions tailored to your desires.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-jewell-sessions.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/sessions` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Sessions & Tribute – ${CompanyName}` },
  {
    name: 'twitter:description',
    content:
      `From soft dominance to intense discipline, ${CompanyName} crafts unforgettable experiences. Submit to true power.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/mistress-jewell-sessions.jpg`,
  },
];
